// Module
var code = "<div class=\"component-editor-destination\"></div>\n";
// Exports
module.exports = code;